module.exports = __webpack_public_path__ + "static/newsletter-img-7bde5c347e7e3eaac92cfc943edf9b0a.png";